<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'artistManagementIndex',
})
</script>
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <router-view v-if="$route.name !== 'artist'" />
  <div v-else class="artist-page">
    <a-card>
      <a-form :model="state.tableData.param" class="global-search-form">
        <a-row :gutter="24">
          <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="5" class="mb-[10px]">
            <a-form-item label="艺术家">
              <a-input v-model:value="state.tableData.param.artistName" placeholder="请输入艺术家姓名" :maxlength="10"
                allow-clear @press-enter="onSearch" />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="5" class="mb-[10px]">
            <a-form-item label="状态">
              <a-select v-model:value="state.tableData.param.status" placeholder="请选择状态" allow-clear>
                <a-select-option :value="1">生效中</a-select-option>
                <a-select-option :value="2">已禁用</a-select-option>
                <a-select-option :value="0">草稿</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="5" class="mb-[10px]">
            <a-form-item label="当前展览展示">
              <a-select v-model:value="state.tableData.param.currentExhibition" placeholder="请选择" allow-clear>
                <a-select-option :value="1">是</a-select-option>
                <a-select-option :value="0">否</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="4" class="mb-[10px]">
            <div class="card-col-action artist-search-actions">
              <ant-button class="search mr-[10px]!" type="primary" @click="onSearch">
                <SearchOutlined />查询
              </ant-button>
              <ant-button class="resetFun" type="primary" @click="onReset">
                <RedoOutlined />重置
              </ant-button>
            </div>
          </a-col>
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="5" class="mb-[10px]">
            <div class="card-col-action flex justify-start lg:justify-end">
              <ant-button class="add" type="primary" @click="onAdd" v-auth="'artist.add'">
                <PlusOutlined />新增艺术家
              </ant-button>
            </div>
          </a-col>
        </a-row>
      </a-form>

      <ant-table :columns="columns" :data-source="state.tableData.data" :loading="state.tableData.loading"
        :pagination="false" row-key="id">
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'index'">
            {{ (state.tableData.param.pageNum - 1) * state.tableData.param.pageSize + index + 1 }}
          </template>
          <template v-else-if="column.key === 'cover'">
            <div v-if="record.cover" class="artist-cover">
              <img :src="record.cover" :alt="record.name || '艺术家照片'" />
            </div>
            <div v-else class="artist-cover artist-cover-empty">
              <UserOutlined />
            </div>
          </template>
          <template v-else-if="column.key === 'name'">
            <span :title="record.name">{{ record.name || '-' }}</span>
          </template>
          <template v-else-if="column.key === 'qrcode'">
            <a-popover placement="bottom" trigger="hover" overlay-class-name="artist-qr-popover"
              @open-change="(open: boolean) => onQrPopoverOpen(record.id, open)">
              <template #content>
                <div class="artist-qr-preview">
                  <div v-if="qrPreviewFailed[String(record.id)]" class="artist-qr-error">
                    二维码加载失败
                  </div>
                  <img v-else :src="getQrCodeUrl(record.id)" :alt="`${record.name || '艺术家'}二维码`"
                    @error="onQrPreviewError(record.id)" />
                  <button
                    type="button"
                    class="artist-qr-download"
                    :disabled="qrDownloadLoading[String(record.id)]"
                    @click="onDownloadQrCode(record)"
                  >
                    {{ qrDownloadLoading[String(record.id)] ? '下载中...' : '下载二维码' }}
                  </button>
                </div>
              </template>
              <QrcodeOutlined class="artist-qr-icon" />
            </a-popover>
          </template>
          <template v-else-if="column.key === 'status'">
            <span class="artist-status">{{ getStatusText(record.status) }}</span>
          </template>
          <template v-else-if="column.key === 'currentExhibition'">
            <a-switch class="artist-exhibition-switch" :checked="record.currentExhibition === 1"
              :loading="exhibitionLoading[String(record.id)]" checked-children="是" un-checked-children="否"
              :disabled="!canEditArtist"
              @change="(checked: boolean) => onChangeExhibition(record, checked)" />
          </template>
          <template v-else-if="column.key === 'createTime'">
            {{ formatDateTime(record.createTime) }}
          </template>
          <template v-else-if="column.key === 'action'">
            <div class="table-action-left artist-actions">
              <a-button type="link" size="small" @click="onEdit(record)" v-auth="'artist.edit'">编辑</a-button>
              <a-button v-if="record.status !== 0" type="link" size="small" @click="onChangeStatus(record)"
                v-auth="'artist.freeze'">{{ record.status === 1 ? '禁用' : '启用' }}</a-button>
              <a-button type="link" size="small" danger @click="onDelete(record)" v-auth="'artist.del'">删除</a-button>
            </div>
          </template>
        </template>
      </ant-table>

      <ant-pagination v-model:current="state.tableData.param.pageNum" v-model:page-size="state.tableData.param.pageSize"
        :total="state.tableData.total" :page-size-options="['10', '20']" show-size-changer
        :show-total="(total: number) => `共 ${total} 条`" :showQuickJumper="true" @change="onPageChange"
        @show-size-change="onShowSizeChange" />
    </a-card>
  </div>
</template>

<script setup lang="ts" name="artistManagementIndex">
import { computed, h, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { message, Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined, PlusOutlined, QrcodeOutlined, RedoOutlined, SearchOutlined, UserOutlined } from '@ant-design/icons-vue'
import dayjs from 'dayjs'
import { useArtist, type ArtistListItem, type ArtistStatus, type ExhibitionFlag } from '@/store/artist/artist'
import { useLogin } from '@/store/login'
import { fetchWithPaginationFallback } from '@/utils/paginationFallback'
import baseService from '@/utils/http/axios'

const route = useRoute()
const router = useRouter()
const artistStore = useArtist()
const loginStore = useLogin()
const exhibitionLoading = ref<Record<string, boolean>>({})
const qrDownloadLoading = ref<Record<string, boolean>>({})
const qrPreviewFailed = ref<Record<string, boolean>>({})
const qrPreviewVersion = ref<Record<string, number>>({})
const canEditArtist = computed(() => {
  return (loginStore.userInfos as any)?.roleType === 'admin' || loginStore.getAuthBtnList().includes('artist.edit')
})

const columns = [
  { title: '序号', key: 'index', width: 70, align: 'center' },
  { title: '照片', key: 'cover', ellipsis: true, align: 'center' },
  { title: '艺术家', dataIndex: 'name', key: 'name', ellipsis: true, align: 'center' },
  { title: '二维码', key: 'qrcode', ellipsis: true, align: 'center' },
  { title: '状态', dataIndex: 'status', key: 'status', width: 150, align: 'center' },
  { title: '创建时间', dataIndex: 'createTime', key: 'createTime', width: 180, align: 'center' },
  { title: '当前展览展示', dataIndex: 'currentExhibition', key: 'currentExhibition', width: 180, align: 'center' },
  { title: '操作', key: 'action', width: 220, align: 'center' }
]

const state = reactive({
  tableData: {
    data: [] as ArtistListItem[],
    total: 0,
    loading: false,
    param: {
      pageNum: 1,
      pageSize: 10,
      artistName: '',
      status: undefined as ArtistStatus | undefined,
      currentExhibition: undefined as ExhibitionFlag | undefined
    }
  }
})

const getStatusText = (status?: ArtistStatus) => {
  if (status === 0) return '草稿'
  if (status === 1) return '生效中'
  if (status === 2) return '已禁用'
  return '未知'
}

const formatDateTime = (value?: string) => {
  if (!value) return '-'
  const date = dayjs(value)
  return date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss') : value
}

const getQrCodeUrl = (id: string | number) => {
  const baseURL = String(import.meta.env.VITE_PROXY || '').replace(/\/+$/, '')
  const url = `${baseURL}/console/art/artist/qrcode/${id}`
  const version = qrPreviewVersion.value[String(id)]
  return version ? `${url}?_t=${version}` : url
}

const onQrPreviewError = (id: string | number) => {
  qrPreviewFailed.value[String(id)] = true
}

const onQrPopoverOpen = (id: string | number, open: boolean) => {
  if (!open) return
  const key = String(id)
  if (!qrPreviewFailed.value[key]) return
  qrPreviewFailed.value[key] = false
  qrPreviewVersion.value[key] = Date.now()
}

const onDownloadQrCode = async (record: ArtistListItem) => {
  const key = String(record.id)
  if (qrDownloadLoading.value[key]) return

  qrDownloadLoading.value[key] = true
  try {
    const response = await baseService<Blob>({
      url: `/console/art/artist/qrcode/${record.id}`,
      method: 'get',
      responseType: 'blob'
    })
    // 响应拦截器会直接返回 response.data，同时兼容未解包的 AxiosResponse
    const blob = response instanceof Blob ? response : response.data
    if (!blob.size || (blob.type && !blob.type.startsWith('image/') && blob.type !== 'application/octet-stream')) {
      throw new Error('二维码响应不是有效图片')
    }

    const extension = blob.type.includes('svg')
      ? 'svg'
      : blob.type.includes('webp')
        ? 'webp'
        : blob.type.includes('jpeg')
          ? 'jpg'
          : 'png'
    const fileName = `${record.name || '艺术家'}-二维码.${extension}`.replace(/[\\/:*?"<>|]/g, '_')
    const objectUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0)
  } catch (error) {
    message.error('二维码下载失败，请重试')
  } finally {
    qrDownloadLoading.value[key] = false
  }
}

const getTableData = async () => {
  state.tableData.loading = true
  try {
    const data = await fetchWithPaginationFallback<ArtistListItem>((param) => artistStore.getArtistPage(param as any), state.tableData.param)
    state.tableData.data = data.records || []
    state.tableData.total = data.total || 0
    state.tableData.param.pageNum = data.pageNum ?? state.tableData.param.pageNum
  } finally {
    state.tableData.loading = false
  }
}

const onSearch = () => {
  state.tableData.param.pageNum = 1
  getTableData()
}

const onReset = () => {
  state.tableData.param.artistName = ''
  state.tableData.param.status = undefined
  state.tableData.param.currentExhibition = undefined
  state.tableData.param.pageNum = 1
  getTableData()
}

const onAdd = () => {
  router.push({ name: 'artistAdd' })
}

const onEdit = (record: ArtistListItem) => {
  router.push({ name: 'artistEdit', params: { id: String(record.id) } })
}

const onChangeStatus = (record: ArtistListItem) => {
  const targetStatus: 1 | 2 = record.status === 1 ? 2 : 1
  const actionText = targetStatus === 1 ? '启用' : '禁用'
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: `是否确认${actionText}艺术家“${record.name}”？`,
    okText: '确认',
    cancelText: '取消',
    onOk: async () => {
      await artistStore.changeArtistStatus(record.id, targetStatus)
      message.success(`${actionText}成功`)
      await getTableData()
    }
  })
}

const onChangeExhibition = async (record: ArtistListItem, checked: boolean) => {
  const key = String(record.id)
  exhibitionLoading.value[key] = true
  try {
    const targetValue: ExhibitionFlag = checked ? 1 : 0
    await artistStore.changeArtistExhibition(record.id, targetValue)
    record.currentExhibition = targetValue
    message.success('当前展览状态更新成功')
  } finally {
    exhibitionLoading.value[key] = false
  }
}

const onDelete = (record: ArtistListItem) => {
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: `此操作将永久删除艺术家“${record.name}”，是否继续？`,
    okText: '确认',
    cancelText: '取消',
    onOk: async () => {
      await artistStore.deleteArtist(record.id)
      message.success('删除成功')
      await getTableData()
    }
  })
}

const onPageChange = (page: number) => {
  state.tableData.param.pageNum = page
  getTableData()
}

const onShowSizeChange = (_current: number, size: number) => {
  state.tableData.param.pageSize = size
  state.tableData.param.pageNum = 1
  getTableData()
}

onMounted(getTableData)

watch(
  () => route.name,
  (name) => {
    if (name === 'artist') getTableData()
  }
)
</script>

<style scoped lang="less">
.artist-search-actions {
  display: flex;
  white-space: nowrap;
}

.artist-cover {
  display: inline-block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  vertical-align: middle;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.artist-cover-empty {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: #90909a;
  background: #f3f3f5;
  font-size: 22px;
}

.artist-qr-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  color: #5c5757;
  font-size: 30px;
  line-height: 1;
  cursor: pointer;

  :deep(svg) {
    width: 30px;
    height: 30px;
  }
}

.artist-status {
  color: #5c5757;
}

.artist-actions {
  justify-content: center;
}

:deep(.artist-exhibition-switch.ant-switch-checked) {
  background-color: #0f813d;
}

:deep(.artist-exhibition-switch.ant-switch-checked:hover:not(.ant-switch-disabled)) {
  background-color: #0a6b31;
}
</style>

<style lang="less">
.artist-qr-popover {
  .ant-popover-inner {
    padding: 18px;
  }
}

.artist-qr-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  img {
    width: 160px;
    height: 160px;
    object-fit: contain;
  }

  .artist-qr-error {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 160px;
    color: #999;
    background: #f7f7f7;
  }

  .artist-qr-download {
    padding: 0;
    border: 0;
    color: #222;
    background: transparent;
    font: inherit;
    text-decoration: underline;
    text-underline-offset: 2px;
    cursor: pointer;

    &:disabled {
      color: #999;
      cursor: not-allowed;
    }
  }
}
</style>
